module.exports = __webpack_public_path__ + "static/media/clock.d170d691.svg";